// Reuse the early HTML SDK request; all React consumers share one readiness promise.
function createGoogleIdentityLoader(win, doc, schedule = setTimeout, cancel = clearTimeout) {
  let pending;
  return function loadGoogleIdentity() {
    if (win.google?.accounts?.id) return Promise.resolve(win.google.accounts.id);
    if (pending) return pending;
    pending = new Promise((resolve, reject) => {
      let script = doc.getElementById('kelimo-google-identity');
      const created = !script;
      if (!script) {
        script = doc.createElement('script');
        script.id = 'kelimo-google-identity';
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
      }
      let timeout;
      const clean = () => { cancel(timeout); script.removeEventListener('load', ready); script.removeEventListener('error', failed); };
      const failed = () => {
        clean(); script.remove();
        reject(new Error('Google giriş aracı yüklenemedi. Yeniden deneyebilirsin.'));
      };
      const ready = () => {
        if (!win.google?.accounts?.id) return failed();
        clean(); resolve(win.google.accounts.id);
      };
      script.addEventListener('load', ready);
      script.addEventListener('error', failed);
      timeout = schedule(failed, 15000);
      if (created) doc.head.appendChild(script);
      // Covers a cached script becoming ready between the initial check and subscription.
      if (win.google?.accounts?.id) ready();
    }).catch(error => { pending = null; throw error; });
    return pending;
  };
}
let browserLoader;
function loadGoogleIdentity() {
  if (!browserLoader) browserLoader = createGoogleIdentityLoader(window, document);
  return browserLoader();
}
module.exports = { createGoogleIdentityLoader, loadGoogleIdentity };
